import Section from "../Section";
import QuickAdd from '../global/QuickAdd';
import KenBurns from '../global/KenBurns';

export default class ShopTheLook extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.attachEvents();

    this.quickAddButtons = new QuickAdd(window.wetheme, element);
    this.kenBurns = new KenBurns(theme, element);
    this.theme.addBadges(this.element, 1000);
  }

  attachEvents() {
    // The css transform applied by the global fadeInUp animation breaks the fixed positioning of the section modal, so we need to remove it once the animation is complete
    this.element.addEventListener('animationend', (e) => {
      if (e.animationName === 'fadeIn') {
        this.element.classList.remove('fadeIn');
      }
    });
  }

  onSectionSelect = () => {
    this.kenBurns.reapply();
  }
}
